import { render, staticRenderFns } from "./roomInvoiceRed.vue?vue&type=template&id=4a1c6640&scoped=true"
import script from "./roomInvoiceRed.vue?vue&type=script&lang=js"
export * from "./roomInvoiceRed.vue?vue&type=script&lang=js"
import style0 from "./roomInvoiceRed.vue?vue&type=style&index=0&id=4a1c6640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1c6640",
  null
  
)

export default component.exports